import { cn } from "@/lib/utils";

const TINTS = {
  blue: "bg-blue-50 text-blue-600",
  amber: "bg-amber-50 text-amber-600",
  red: "bg-red-50 text-red-600",
  green: "bg-emerald-50 text-emerald-600",
  purple: "bg-violet-50 text-violet-600",
  slate: "bg-slate-100 text-slate-600",
};

export default function StatCard({ label, value, icon: Icon, tint = "blue", accent, testId, onClick }) {
  return (
    <div
      data-testid={testId}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      className={cn(
        "rounded-xl border border-border bg-card p-5 transition-all hover:border-primary/40 hover:shadow-sm",
        onClick && "cursor-pointer hover:-translate-y-0.5"
      )}
    >
      <div className="flex items-start justify-between">
        <p className="overline">{label}</p>
        {Icon && (
          <span className={cn("flex h-9 w-9 items-center justify-center rounded-lg", TINTS[tint])}>
            <Icon size={18} />
          </span>
        )}
      </div>
      <p className={cn("mt-3 text-3xl font-extrabold tracking-tight", accent || "text-navy")}>
        {value}
      </p>
    </div>
  );
}
